<div class="payment-flow-container">
  <div class="grid equal-height-grid">
    <div class="col-12 lg:col-7">
      <p-card header="Billing Information" styleClass="billing-card">
        <form [formGroup]="billingForm" class="flex flex-column gap-3 mt-4">
          <div class="field">
            <label for="fullName" class="font-semibold">Full Name <span class="text-red-500">*</span></label>
            <input pInputText id="fullName" formControlName="fullName" class="w-full"
              [ngClass]="{'ng-invalid ng-dirty': billingForm.get('fullName')?.invalid && (billingForm.get('fullName')?.touched || formSubmitted)}"
              (input)="formatNameInput($event, 'fullName')" />
            <small class="p-error" *ngIf="billingForm.get('fullName')?.hasError('required') &&
        (billingForm.get('fullName')?.touched || formSubmitted)">
              Full name is required
            </small>

            <small class="p-error" *ngIf="(billingForm.get('fullName')?.hasError('fullName') ||
          billingForm.get('fullName')?.hasError('pattern')) &&
        (billingForm.get('fullName')?.touched || formSubmitted)">
              Please enter a valid full name
            </small>
          </div>

          <div class="field">
            <label for="emailAddress" class="font-semibold">Email Address <span class="text-red-500">*</span></label>
            <input pInputText id="emailAddress" formControlName="emailAddress" type="email" class="w-full" />
            <small class="p-error" *ngIf="billingForm.get('emailAddress')?.hasError('required') &&
        (billingForm.get('emailAddress')?.touched || formSubmitted)">
              Email address is required
            </small>

            <small class="p-error" *ngIf="(billingForm.get('emailAddress')?.hasError('email') ||
          billingForm.get('emailAddress')?.hasError('pattern')) &&
        (billingForm.get('emailAddress')?.touched || formSubmitted)">
              Please enter a valid email address
            </small>

          </div>

          <div class="field">
            <label for="billingAddress" class="font-semibold">Billing Address <span
                class="text-red-500">*</span></label>
            <input pInputText id="billingAddress" formControlName="billingAddress" class="w-full" />
            <small class="p-error" *ngIf="billingForm.get('billingAddress')?.hasError('required') &&
        (billingForm.get('billingAddress')?.touched || formSubmitted)">
              Billing address is required
            </small>

            <small class="p-error" *ngIf="billingForm.get('billingAddress')?.hasError('minlength') &&
        (billingForm.get('billingAddress')?.touched || formSubmitted)">
              Address must be at least 10 characters long
            </small>

          </div>

          <div class="field">
            <label for="phoneNumber" class="font-semibold">Phone Number <span class="text-red-500">*</span></label>
            <input pInputText id="phoneNumber" formControlName="phoneNumber" class="w-full"
              (input)="formatPhoneNumber($event)" maxlength="10" />
            <small class="p-error" *ngIf="billingForm.get('phoneNumber')?.hasError('required') &&
        (billingForm.get('phoneNumber')?.touched || formSubmitted)">
              Phone number is required
            </small>

            <small class="p-error" *ngIf="billingForm.get('phoneNumber')?.hasError('pattern') &&
        (billingForm.get('phoneNumber')?.touched || formSubmitted)">
              Please enter a valid 10-digit phone number (numbers only)
            </small>

          </div>

        </form>
      </p-card>

      <p-card styleClass="billing-terms-card">
        <form [formGroup]="billingForm" style="padding: 0 !important;">
          <div class="field-checkbox flex align-items-center gap-2">
            <p-checkbox formControlName="agreeToTerms" [binary]="true" inputId="agreeToTerms"></p-checkbox>

            <label for="agreeToTerms">
              I agree to the terms and conditions <span class="text-red-500">*</span>
            </label>
          </div>

          <small class="p-error block mt-2" *ngIf="billingForm.get('agreeToTerms')?.invalid &&
          (billingForm.get('agreeToTerms')?.touched || formSubmitted)">
            You must agree to the terms and conditions
          </small>
        </form>
      </p-card>
    </div>

    <div class="col-12 lg:col-5">
      <p-card header="Order Summary" styleClass="order-summary-card"
        class="border-1 border-round-xl border-bluegray-100 overflow-hidden">
        <div class="flex flex-column gap-3 mt-3">
          <div class="flex flex-column gap-2">
            <h4 class="font-semibold">{{ orderSummary?.testName }}</h4>
            <p class="text-sm" [innerHTML]="orderSummary?.description"></p>
          </div>

          <div class="flex flex-column gap-2 pt-3 border-top-1 border-bluegray-100">
            <h4 class="font-semibold">Duration</h4>
            <p class="text-sm">{{ orderSummary?.duration }}</p>
          </div>



          <div class="flex flex-column gap-2 py-3 border-y-1 border-bluegray-100">
            <h4 class="font-semibold">What's Included</h4>
            <ul class="included-list">
              <li *ngFor="let item of orderSummary?.whatsIncluded" class="flex gap-2 align-items-start mb-2">
                <i class="pi pi-check-circle text-green-500 mt-1"></i>
                <span class="text-sm">{{ item }}</span>
              </li>
            </ul>
          </div>



          <div class="price-breakdown">
            <div class="flex justify-content-between  mb-2">
              <span>Subtotal</span>
              <span class="font-semibold"><i class="pi pi-indian-rupee" style="font-size: 0.7rem"></i>{{
                orderSummary?.subtotal?.toFixed(2) }}</span>
            </div>
            <div class="flex justify-content-between mb-2">
              <span>Tax</span>
              <span class="font-semibold"><i class="pi pi-indian-rupee" style="font-size: 0.7rem"></i>{{
                orderSummary?.tax?.toFixed(2) }}</span>
            </div>
            <p-divider></p-divider>
            <div class="flex justify-content-between">
              <span class="text-xl font-bold">Total</span>
              <span class="text-xl font-bold text-primary"><i class="pi pi-indian-rupee"
                  style="font-size: 0.7rem"></i>{{ orderSummary?.total?.toFixed(2) }}</span>
            </div>
          </div>

          <div class="flex flex-column gap-2 mt-3">
            <p-button label="Confirm and Proceed to Payment" [loading]="processingPayment"
              [disabled]="processingPayment" icon="pi pi-arrow-right" iconPos="right" (click)="onSubmit()"
              styleClass="p-button-primary w-full button_submit"></p-button>
          </div>
        </div>
      </p-card>
    </div>
  </div>
</div>